import React from "react";
import { Button } from "@fluentui/react-northstar";
import { useGraph } from "../lib/useGraph";
import { NewProfileCard } from "./NewProfileCard";

interface INewGraph {
  updateUserData: any;
}

export function NewGraph(props: INewGraph) {
  const { loading, error, data, reload } = useGraph(
    async (graph) => {
      const organization = (await graph.api("/organization")
        .get()
      ).value[0];
      const profile = await graph.api("/me").get();
      let photoUrl = "";
      try {
        const photo = await graph.api("/me/photo/$value").get();
        photoUrl = URL.createObjectURL(photo);
      } catch {
        // Could not fetch photo from user's profile, return empty string as placeholder.
      }
      
      const graphData = { profile, photoUrl, organization }
      
      props.updateUserData(graphData);
      return graphData;
    },
    { scope: ["User.Read"] }
  );

  return (
    <div>
      {loading && NewProfileCard(true)}
      {!loading && error && <div className="error">{error.toString()}</div>}
      {!loading && data && NewProfileCard(false, data)}
      <Button primary content="Authorize" disabled={loading} onClick={reload} />
    </div>
  );
}
